function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { isFocusVisible as $isWE5$isFocusVisible, useFocusVisibleListener as $isWE5$useFocusVisibleListener, useFocus as $isWE5$useFocus, useFocusWithin as $isWE5$useFocusWithin } from "@react-aria/interactions";
import { useRef as $isWE5$useRef, useState as $isWE5$useState, useCallback as $isWE5$useCallback } from "react";
function $f7dceffc5ad7768b$export$4e328f61c538687f() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    isTextInput = props.isTextInput,
    within = props.within;
  var state = (0, $isWE5$useRef)({
    isFocused: false,
    isFocusVisible: autoFocus || (0, $isWE5$isFocusVisible)()
  });
  var _ref = (0, $isWE5$useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    isFocused = _ref2[0],
    setFocused = _ref2[1];
  var _ref3 = (0, $isWE5$useState)(function () {
      return state.current.isFocused && state.current.isFocusVisible;
    }),
    _ref4 = _slicedToArray(_ref3, 2),
    isFocusVisibleState = _ref4[0],
    setFocusVisible = _ref4[1];
  var updateState = (0, $isWE5$useCallback)(function () {
    return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
  }, []);
  var onFocusChange = (0, $isWE5$useCallback)(function (isFocused) {
    state.current.isFocused = isFocused;
    setFocused(isFocused);
    updateState();
  }, [updateState]);
  (0, $isWE5$useFocusVisibleListener)(function (isFocusVisible) {
    state.current.isFocusVisible = isFocusVisible;
    updateState();
  }, [], {
    isTextInput: isTextInput
  });
  var _ref5 = (0, $isWE5$useFocus)({
      isDisabled: within,
      onFocusChange: onFocusChange
    }),
    focusProps = _ref5.focusProps;
  var _ref6 = (0, $isWE5$useFocusWithin)({
      isDisabled: !within,
      onFocusWithinChange: onFocusChange
    }),
    focusWithinProps = _ref6.focusWithinProps;
  return {
    isFocused: isFocused,
    isFocusVisible: isFocusVisibleState,
    focusProps: within ? focusWithinProps : focusProps
  };
}
export { $f7dceffc5ad7768b$export$4e328f61c538687f as useFocusRing };